module.exports = "https://trybtryb-legacy.web.app/img/funky-fuzz.4bc6161e.webp";